import React from "react";
import best9 from "../assets/best9.jpg";
import "../style/bestSeller.css";

function BestSeller9() {
  return (
    <div>
      <img src={best9} alt="best seller images" className="best" />
    </div>
  );
}

export default BestSeller9;
